import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"


export default function AppTiersAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Tiers"
		placeholder="Select any tier"
		{...props}
	/>
}